import React from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

export function PageHeader({ title, subtitle, breadcrumbs = [], actions = null }) {
    return (
        <div className="mb-6" data-testid="page-header">
            {breadcrumbs.length > 0 && (
                <nav className="flex items-center gap-1 text-xs text-[#64748B] mb-2">
                    {breadcrumbs.map((b, i) => (
                        <React.Fragment key={i}>
                            {i > 0 && <ChevronRight className="w-3 h-3" />}
                            {b.href ? (
                                <Link to={b.href} className="hover:text-[#2563EB] transition-colors">
                                    {b.label}
                                </Link>
                            ) : (
                                <span className="text-[#172033] font-medium">{b.label}</span>
                            )}
                        </React.Fragment>
                    ))}
                </nav>
            )}
            <div className="flex items-start justify-between gap-4 flex-wrap">
                <div>
                    <h1 className="text-2xl font-bold text-[#172033] tracking-tight" data-testid="page-title">
                        {title}
                    </h1>
                    {subtitle && (
                        <p className="text-sm text-[#64748B] mt-1 max-w-2xl">{subtitle}</p>
                    )}
                </div>
                {actions && <div className="flex items-center gap-2">{actions}</div>}
            </div>
        </div>
    );
}

export default PageHeader;
